import { useState } from 'react';
import PropTypes from 'prop-types';
import ProviderConnectionConnect from 'Components/Organisms/ProviderConnectionConnect/ProviderConnectionConnect';
import Button from 'Components/Atoms/Button/Button';
import { useTranslation } from 'react-i18next';

export default function InvalidCredentials(props) {
    const { providerConnection, onEnableClose, onClose, onClearConnection } = props;
    const [showConnect, setShowConnect] = useState(false);
    const [processing, setProcessing] = useState(false);

    const { t } = useTranslation('providers');

    const handleRetry = () => {
        onClearConnection();
        setShowConnect(true);
        onEnableClose();
    };

    const handleCancel = async () => {
        setProcessing(true);
        await onClearConnection(false);

        setProcessing(false);
        onClose();
    };

    if (!showConnect) {
        return (
            <div className="text-center mb-4">
                <div className="flex justify-center mb-6">
                    <img src="/img/icon-error.svg" alt="" />
                </div>
                <h4>{t('invalid-credentials-title')}</h4>
                <div className="text-gray-500">{t('invalid-credentials-description')}</div>
                <div className="flex justify-center gap-2 mt-6">
                    <Button variant="primary" onClick={handleRetry}>
                        {t('retry')}
                    </Button>
                    <Button isBusy={processing} onClick={handleCancel}>
                        {t('cancel')}
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <ProviderConnectionConnect
            onConnect={onClose}
            onCancel={onClose}
            connector={providerConnection.connector}
            providerConnectionId={providerConnection.provider_connection_reference_id}
            onError={onClose}
        />
    );
}

InvalidCredentials.propTypes = {
    providerConnection: PropTypes.object.isRequired,
    description: PropTypes.string.isRequired,
    info: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onEnableClose: PropTypes.func.isRequired,
    onClearConnection: PropTypes.func.isRequired,
};
